function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { View, useTheme } from 'native-base';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faShieldHalved } from '@fortawesome/pro-solid-svg-icons';
import { Platform } from 'react-native';
const IconShield = props => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const iconStyle = {
    position: 'absolute',
    right: `${props.right}px`
  };
  if (props.top) iconStyle['top'] = `${props.top}px`;else iconStyle['bottom'] = 0;
  let iconProps = {};
  if (Platform.OS === 'web') iconProps.style = iconStyle;else iconProps = {
    ...iconProps,
    ...iconStyle
  };
  return Platform.OS === 'web' ? /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({
    icon: faShieldHalved,
    size: props.size,
    color: colors.createEditButton.shield.icon
  }, iconProps)) : /*#__PURE__*/React.createElement(View, iconProps, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faShieldHalved,
    size: props.size,
    color: colors.createEditButton.shield.icon
  }));
};
export default IconShield;
//# sourceMappingURL=IconShield.js.map